import mod from "-!./requestEvent.js?vue&type=script&lang=js&external"; export default mod; export * from "-!./requestEvent.js?vue&type=script&lang=js&external"